import { ListItemText as MuiListItemText } from "@mui/material";
import { styled } from "@mui/system";

export const MenuListItemText = styled(MuiListItemText)({
  paddingTop: "4px",
  paddingBottom: "4px",
});
